import { BaseBigWinPopup } from './BaseBigWinPopup';

export class BigWinMobilePopup extends BaseBigWinPopup {
  execute({ root }) {
    const popup = this.getPopup({
      scale: 1,
    });
    root.addChild(popup);
  }
}
